import { userRole, checkAvailabilityRole } from 'helpers/user';

export default {
  async checkAuthAndRole(to, from, next) {
    const role = await userRole();
    const roles = to.meta.roles;

    if (!role) return next(`/?redirect=${to.path}`);

    if (roles && checkAvailabilityRole(role, roles)) {
      next();
    } else {
      next({ name: 'access-denied' });
    }
  }
};
